import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import * as periodosService from '../../services/periodos/periodosService';
import {
  buildPeriodoExamenValidationError,
  classifyPeriodosError,
  toUpdatePeriodoExamenPayload,
  validatePeriodDates,
  validatePeriodoExamenFormUpdate,
} from '../../services/periodos/periodosDto';
import { LookupAnioAcademicos } from '../AnioAcademico/LookupAnioAcademicos';
import { parseDate, displayDate, todayCalendarDate } from '../../services/dates/dateService';
import { CalendarDatePicker } from '../common/CalendarDatePicker';

export class UpdatePeriodoExamen extends Component {
  static displayName = UpdatePeriodoExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingData: true,
      descripcion: '',
      showErrorMessage: false,
      success: false,
      errorMessage: '',
      showLookupAnios: false,
      startDate: todayCalendarDate(),
      endDate: todayCalendarDate(),
      llamado: '',
      anio: { anioAcademicoCod: 0, anioAcademicoDescripcion: '' },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWPeriodoExamen');
    if (canAccess) {
      await this.populateData();
    }
  }

  handleConfirmButton = () => {
    const datesOk = validatePeriodDates(this.state.startDate, this.state.endDate);
    const isOkToSave = validatePeriodoExamenFormUpdate({
      descripcion: this.state.descripcion,
      llamado: this.state.llamado,
      anioPresent: this.state.anio != null,
      anioDescripcion: this.state.anio?.anioAcademicoDescripcion,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    });
    const errorMessage = buildPeriodoExamenValidationError({ formValid: isOkToSave, datesOk });

    if (isOkToSave && datesOk) {
      this.saveStudent();
      return;
    }

    this.setState({ showErrorMessage: true, errorMessage });
  };

  async populateData() {
    this.setState({ loadingData: true });
    try {
      const returnModel = await periodosService.getPeriodoExamen(this.state.id);
      this.setState({
        loadingData: false,
        errorMessage: '',
        showErrorMessage: false,
        anio: {
          anioAcademicoCod: returnModel.anioAcademicoCod,
          anioAcademicoDescripcion: returnModel.anioAcademicoDescripcion,
        },
        descripcion: returnModel.periodoExamenDescripcion.trim(),
        llamado: returnModel.periodoExamenLlamado.trim(),
        startDate: parseDate(returnModel.periodoExamenFechaInicio),
        endDate: parseDate(returnModel.periodoExamenFechaFin),
      });
    } catch (error) {
      const outcome = classifyPeriodosError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loadingData: false,
        errorMessage: outcome.message,
      });
    }
  }

  handleShowAniosLookup = () => {
    this.setState({ showLookupAnios: true });
  };

  handleStartDate = (date) => {
    this.setState({ startDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleEndDate = (date) => {
    this.setState({ endDate: date, showErrorMessage: false, errorMessage: '' });
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleDescripcionChangeInput = (e) => {
    this.setState({ descripcion: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handleLlamadoChangeInput = (e) => {
    this.setState({ llamado: e.target.value, showErrorMessage: false, errorMessage: '' });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.setState({
      showLookupAnios: false,
      showErrorMessage: false,
      errorMessage: '',
      anio: {
        anioAcademicoCod: anioProperties[0],
        anioAcademicoDescripcion: anioProperties[1],
      },
    });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-pex" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle de Período de Examen' : 'Modificar Período de Examen';
    const { loading, loadingData } = this.state;
    const isBusy = loading || loadingData;

    return (
      <div className="md-page md-update-pex">
        <Link className="md-page__back-link" to="/md-pex">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados del período de examen.'
            : 'Actualice los datos del período y confirme para guardar los cambios.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {this.state.errorMessage && !this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loadingData ? (
            <div className="md-page__status">Cargando datos...</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="pex-update-descripcion">
              Período de examen
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.descripcion || '\u00a0'}</div>
            ) : (
              <input
                id="pex-update-descripcion"
                className="md-page__field-input"
                type="text"
                value={this.state.descripcion}
                onChange={this.handleDescripcionChangeInput}
                disabled={isBusy}
              />
            )}
          </div>

          <div className="md-page__field">
            <label className="md-page__field-label" htmlFor="pex-update-llamado">
              Llamado
            </label>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.llamado || '\u00a0'}</div>
            ) : (
              <input
                id="pex-update-llamado"
                className="md-page__field-input"
                type="text"
                value={this.state.llamado}
                onChange={this.handleLlamadoChangeInput}
                disabled={isBusy}
              />
            )}
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Año académico</span>
            {!isDetail ? (
              <div className="md-page__picker-block">
                {!isBusy ? (
                  <button type="button" className="md-page__picker-link" onClick={this.handleShowAniosLookup}>
                    Seleccionar año académico
                  </button>
                ) : null}
                <div className="md-page__field-readonly">
                  {this.state.anio.anioAcademicoDescripcion || '\u00a0'}
                </div>
              </div>
            ) : (
              <div className="md-page__field-readonly">
                {this.state.anio.anioAcademicoDescripcion || '\u00a0'}
              </div>
            )}
          </div>

          <section className="md-page__form-section">
            <p className="md-page__form-section-title">Fechas del período</p>
            <div className="md-page__form-date-row">
              <div className="md-page__field">
                <span className="md-page__field-label">Fecha de inicio</span>
                {isDetail ? (
                  <div className="md-page__field-readonly">{displayDate(this.state.startDate) || '\u00a0'}</div>
                ) : (
                  <CalendarDatePicker
                    className="md-page__field-input"
                    selected={this.state.startDate}
                    onChange={this.handleStartDate}
                    disabled={isBusy}
                  />
                )}
              </div>
              <div className="md-page__field">
                <span className="md-page__field-label">Fecha de fin</span>
                {isDetail ? (
                  <div className="md-page__field-readonly">{displayDate(this.state.endDate) || '\u00a0'}</div>
                ) : (
                  <CalendarDatePicker
                    className="md-page__field-input"
                    selected={this.state.endDate}
                    onChange={this.handleEndDate}
                    disabled={isBusy}
                  />
                )}
              </div>
            </div>
          </section>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={isBusy}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupAnios ? (
          <LookupAnioAcademicos selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
        ) : null}
      </div>
    );
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await periodosService.savePeriodoExamen(
        toUpdatePeriodoExamenPayload({
          id: parseInt(this.state.id, 10),
          descripcion: this.state.descripcion,
          llamado: this.state.llamado,
          fechaInicio: this.state.startDate,
          fechaFin: this.state.endDate,
          anioAcademicoCod: parseInt(this.state.anio.anioAcademicoCod, 10),
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = classifyPeriodosError(error);
      if (outcome.type === 'timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      this.setState({
        loading: false,
        success: false,
        showErrorMessage: true,
        errorMessage: outcome.message,
      });
    }
  }
}
